import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "pf_session_id";

function getSessionId() {
  try {
    let sid = sessionStorage.getItem(KEY);
    if (!sid) {
      sid = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(KEY, sid);
    }
    return sid;
  } catch {
    return `s_${Math.random().toString(36).slice(2, 12)}`;
  }
}

async function send(path, event_type = "page_view", event_name = null) {
  try {
    // Skip admin/login pages to avoid noise
    if (path.startsWith("/admin") || path.startsWith("/login")) return;
    const referrer = document.referrer || "";
    const screen = typeof window !== "undefined" ? `${window.innerWidth}x${window.innerHeight}` : "";
    const language = navigator?.language || "";
    await axios.post(`${API}/analytics/track`, {
      session_id: getSessionId(),
      path,
      event_type,
      event_name,
      referrer,
      screen,
      language,
    });
  } catch {
    // silent
  }
}

export function trackEvent(name) {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  send(path, "event", name);
}

export default function useAnalytics() {
  const location = useLocation();
  useEffect(() => {
    // Debounce so we send once per navigation change
    const t = setTimeout(() => {
      send(location.pathname);
    }, 150);
    return () => clearTimeout(t);
  }, [location.pathname]);
}
